
(function documentDefinition() {
    'use strict';
    angular.module('Actions')
        .service('documentAction', [
             '$translate', 'documentService', 'alerts', 'errorsExtend', '$q', 'authExtend', 'fileService', 'fileDownloader',
             function documentAction($translate, documentService, alerts, errors, $q, authExtend, fileService, fileDownloader) {

                 this.downloadFiles = function downloadFiles(document) {
                     var defered = $q.defer();
                     var promise = defered.promise;
                     var tempVersion = (document.checkedOutById != null && document.checkedOutById.toString() === authExtend.getUserId().toString());

                     fileService.downloadFilesDocument(document.id, tempVersion).then(function (result) {
                         var success = fileDownloader.saveAs(result.value, document.name + '.zip');

                         if (!success) {
                             errors.showError('Api failed');
                         }

                         defered.resolve(result);
                     }, function (error) {
                         if (error.status === 204) {
                             errors.showWarning('The document has no files');
                         } else {
                             errors.showError('Api failed');
                         }

                         defered.reject();
                     });

                     return promise;
                 };

                 this.checkIn = function checkIn(docu) {
                     var defered = $q.defer();
                     var promise = defered.promise;

                     var checkInVersioned = authExtend.isInRole('DOCUMENTVERSIONED WRITE');
                     var accesCheckIn = authExtend.isInRole('DOCUMENT WRITE');

                     $translate(['Warning', 'CheckOutConfirmText', 'CheckInCreateVersionConfirmText', 'Yes', 'No']).then(function (translated) {
                         return alerts.confirm(translated.Warning, translated.CheckOutConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                             if (!result) {
                                 defered.reject();
                                 return result;
                             }

                             if (checkInVersioned && accesCheckIn && docu.versionId !== 1) {
                                 return alerts.confirm(translated.Warning, translated.CheckInCreateVersionConfirmText, translated.Yes, translated.No).then(function (createVersion) {

                                     return documentService.checkIn(createVersion, docu).then(function (doc) {
                                         errors.showSuccess('DocumentCheckInSucces');
                                         defered.resolve(doc);
                                     }, function (error) {
                                         errors.showError(error);
                                         defered.reject();
                                     });
                                 });
                             } else {
                                 return documentService.checkIn(checkInVersioned, docu).then(function getOks(doc) {
                                     errors.showSuccess('DocumentCheckInSucces');
                                     defered.resolve(doc);
                                 }, function (error) {
                                     errors.showError(error);
                                     defered.reject();
                                 });
                             }
                         });
                     });

                     return promise;
                 };

                 this.deleteDocument = function deleteDoc(docu) {
                     var defered = $q.defer();
                     var promise = defered.promise;

                     $translate(['Warning', 'DocumentDeleteConfirmText', 'Yes', 'No']).then(function (translated) {
                         return alerts.confirm(translated.Warning, translated.DocumentDeleteConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                             if (!result) {
                                 defered.reject();
                                 return result;
                             }
                             return documentService.delete(docu).then(function getOks(doc) {
                                 errors.showSuccess('DocumentDeleteSuccess');
                                 defered.resolve(doc);

                             }, function (error) {
                                 errors.showError(error);
                                 defered.reject();
                             });
                         });
                     });

                     return promise;
                 };

                 this.checkOut = function checkOut(docu) {
                     var defered = $q.defer();
                     var promise = defered.promise;

                     documentService.checkout(docu)
                         .then(function getOk(result) {
                             errors.showSuccess('DocumentCheckOutSucces');
                             defered.resolve(result);

                         }, function (error) {
                             errors.showError(error);
                             defered.reject();
                         });

                     return promise;
                 };
             }
        ]);

})();